import { render } from "./ClassroomVideo.vue?vue&type=template&id=61b865b8&scoped=true"
import script from "./ClassroomVideo.vue?vue&type=script&lang=js"
export * from "./ClassroomVideo.vue?vue&type=script&lang=js"

import "./ClassroomVideo.vue?vue&type=style&index=0&id=61b865b8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b865b8"]])

export default __exports__